import { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import ChevronLeft from '@mui/icons-material/ChevronLeft';
import { IconButton, Tab, Tabs } from '@mui/material';

import usePermissions from '../../api/usePermissions';
import { useUserPermissions } from '../../hooks/useUserPermissions';
import { UISliceState } from '../../store/store.types';
import { uiActions } from '../../store/uiSlice';
import { unsavedChangesUtil } from '../../utils/unsavedChangesUtil';
import AcSearch from '../AcSearch/AcSearch';
import ActionButton from '../ActionButton/ActionButton';
import AcTooltip from '../AcTooltip/AcTooltip';
import Typography from '../Typography/Typography';

import { ViewHeaderProps } from './PageTopbar.types';

import './style.scss';

const PageTopBar = ({
  headline,
  tabs,
  backFunction,
  disable,
  buttons,
  search,
  withTabsDesign,
  isBackButtonVisible = true
}: ViewHeaderProps) => {
  const [tabsValue, setTabsValue] = useState(0);
  const uiState = useSelector(({ ui }: { ui: UISliceState }) => ui);
  const dispatch = useDispatch();
  const { generateTooltipEditPermissionString } = useUserPermissions();
  const { canUserEdit } = usePermissions();

  const handleTabsChange = (_: unknown, newValue: number) => {
    setTabsValue(newValue);
    tabs && tabs.callback && tabs.callback(newValue);
  };

  const handleBackPress = () => {
    if (uiState.isUnsavedChanges) {
      dispatch(uiActions.setUnsavedChangesModalOpen(true));
      unsavedChangesUtil.func = backFunction as any;
    } else {
      backFunction?.();
    }
  };

  return (
    <>
      <div className="viewHeader">
        <div
          className={`topbar ${withTabsDesign ? 'tabs-state' : 'base-state'}`}
        >
          <div className="headline">
            {backFunction && isBackButtonVisible && (
              <IconButton onClick={handleBackPress} className="backButton">
                <ChevronLeft fontSize="large" />
              </IconButton>
            )}
            <Typography tag="h3">{headline}</Typography>
          </div>
          <div className="header-buttons">
            {buttons?.map((button: any, i: number) =>
              !button.hidden ? (
                <ActionButton
                  key={i}
                  variant={button.variant || 'contained'}
                  size="small"
                  onClick={button.action}
                  sx={{
                    textTransform: 'capitalize'
                  }}
                  disabled={button.disabled || disable}
                  icon={button.icon}
                  text={button.text}
                  tooltip={
                    !canUserEdit ? (
                      <AcTooltip
                        content={generateTooltipEditPermissionString()}
                      />
                    ) : (
                      ''
                    )
                  }
                />
              ) : null
            )}
            {search && (
              <AcSearch
                categories={search.searchCategories}
                callback={search.searchCallback}
              />
            )}
          </div>
        </div>
        {tabs && (
          <div style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.12)' }}>
            <Tabs value={tabsValue} onChange={handleTabsChange}>
              {tabs.list.map((tab, i) => (
                <Tab
                  style={{ textTransform: 'capitalize' }}
                  key={i}
                  label={tab.text}
                />
              ))}
            </Tabs>
          </div>
        )}
      </div>
    </>
  );
};

export default PageTopBar;
